import { render, staticRenderFns } from "./PopupAddNewPage.vue?vue&type=template&id=5173fb7d&scoped=true&"
import script from "./PopupAddNewPage.vue?vue&type=script&lang=js&"
export * from "./PopupAddNewPage.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddNewPage.vue?vue&type=style&index=0&id=5173fb7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173fb7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5173fb7d')) {
      api.createRecord('5173fb7d', component.options)
    } else {
      api.reload('5173fb7d', component.options)
    }
    module.hot.accept("./PopupAddNewPage.vue?vue&type=template&id=5173fb7d&scoped=true&", function () {
      api.rerender('5173fb7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/PopupAddNewPage.vue"
export default component.exports